/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import type { SimulationEmail } from '@app/@types/redux/pageElement';
import { redirectToExternal } from '@app/routes/helpers';
import {
  CardImg,
  CardTitle,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ListGroup,
  UncontrolledDropdown,
} from '@components/UI/Html';
import { getParsedEmailBody, stripHtml } from '@libs/helper';
import { i18nCText } from '@libs/i18n/I18n';
import logger from '@libs/log';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useAppSelector } from '@state/redux/store';
import expEndpoints from '@state/utils/Api';
import { decodeHTMLEntities, translate } from '@state/utils/helper';
import classnames from 'classnames';
import DOMPurify from 'dompurify';
import moment from 'moment';
import 'quill/dist/quill.snow.css';
import { forwardRef, useEffect, useState } from 'react';
import EllipsisText from 'react-ellipsis-text/lib/components/EllipsisText';
import { FaPlay, FaPlusCircle } from 'react-icons/fa';
import { GrAttachment } from 'react-icons/gr';
import { IoCloseSharp } from 'react-icons/io5';
import { MdOutlineAttachment } from 'react-icons/md';
import { PiPaperclip } from 'react-icons/pi';
import { VscCoffee } from 'react-icons/vsc';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactTimeago from 'react-timeago';
import {
  Badge,
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import SampleImage from './Sample.png';
import './index.scss';

interface EmailMessengerProps {
  onClose?: () => void;
  emails: SimulationEmail[];
  isLoading?: boolean;
  onEmailClick?: (email: SimulationEmail) => void;
  filter?: string;
  inboxElementId?: string;
}
export const ImageWithPlayIcon = () => {
  return (
    <div className="image-container">
      <CardImg className="default__email__image" alt="..." src={SampleImage} top />
      <FaPlay className="play-icon" />
    </div>
  );
};
const EmailMessenger = ({
  onClose,
  emails: propEmails = [],
  isLoading = false,
  onEmailClick,
  filter,
  inboxElementId,
}: EmailMessengerProps) => {
  const emails = [...propEmails];
  const [filterType, setFilterType] = useState(filter);
  const [selectedEmail, setSelectedEmail] = useState<SimulationEmail | null>(null);
  const [selectedDropdown, setSelectedDropdown] = useState(
    filterType === 'manager-feedback-email' ? 'Feedback' : 'Inbox'
  );

  useEffect(() => {
    if (selectedDropdown === 'Inbox') {
      setFilterType('');
    } else if (selectedDropdown === 'Feedback') {
      setFilterType('manager-feedback-email');
    } else if (selectedDropdown === 'Unread') {
      setFilterType('unread');
    }
  }, [selectedDropdown]);

  // Update selected email when loading finishes and emails are available

  const handleEmailSelect = (email: SimulationEmail) => {
    setSelectedEmail(email);
    if (onEmailClick) {
      onEmailClick(email);
    }
  };

  // Determine if we're in a modal or on a page
  const containerClass = onClose ? 'email__modal' : 'email__page';

  const filteredEmails =
    filterType === 'manager-feedback-email'
      ? emails.filter((email) => {
          return email.attributes.simulationEmail.attributes.emailType === 'manager-feedback-email';
        })
      : filterType === 'unread'
      ? emails.filter((email) => {
          return !email.attributes.openedAt;
        })
      : emails;

  useEffect(() => {
    if (!isLoading && filteredEmails.length > 0 && !selectedEmail) {
      const firstEmail = filteredEmails[0];
      setSelectedEmail(firstEmail);
    }
  }, [isLoading, selectedEmail, filteredEmails]);

  const currentInboxEmailExists = Boolean(
    filteredEmails.find((email) => email.attributes.inboxElementId == inboxElementId)?.id
  );

  return (
    <div className={`email__main_container ${containerClass}`}>
      <div className="email__main__header">
        <UncontrolledDropdown>
          <DropdownToggle caret color="secondary" className="custom-dropdown-toggle">
            {selectedDropdown}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => {
                setSelectedDropdown('Inbox');
              }}
            >
              {translate('email.inbox')}
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                setSelectedDropdown('Feedback');
              }}
            >
              Feedback
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                setSelectedDropdown('Unread');
              }}
            >
              {translate('email.unread')}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <div className="d-flex align-items-center" id="projectHeaderProgressTooltip">
          {onClose && <IoCloseSharp size={24} onClick={onClose} />}
        </div>
      </div>
      {isLoading ? (
        <div className="email__empty__container">
          <h3>{translate('email.loading')}</h3>
          <p>{translate('email.loadingDescription')}</p>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">{translate('email.loading')}</span>
          </div>
        </div>
      ) : filterType === 'manager-feedback-email' && !currentInboxEmailExists ? (
        <div className="email__empty__container">
          <VscCoffee size={100} color="rgba(136, 152, 170, 0.8)" />
          <h3 className="text-muted mt-3">Your manager is currently reviewing your work.</h3>
          <p className="text-muted">
            Feedback can take a few minutes to arrive via email.
            <br />
            You’ve earned that 5-minute coffee break — enjoy it while you wait!
          </p>
        </div>
      ) : filteredEmails.length === 0 ? (
        <div className="email__empty__container">
          <h3>{translate('email.noEmails')}</h3>
          <p>{translate('email.noEmailsDescription')}</p>
        </div>
      ) : (
        <div className="email_chat-container">
          <div className="email_left_side">
            <PerfectScrollbar>
              <div className="scrollbar-inner">
                <ListGroup flush>
                  {filteredEmails.map((email) => (
                    <EmailMenu
                      key={email.id}
                      email={email}
                      onClick={() => {
                        handleEmailSelect(email);
                      }}
                      selected={selectedEmail?.id === email.id}
                    />
                  ))}
                </ListGroup>
              </div>
            </PerfectScrollbar>
          </div>
          <div className="email_right_side">
            <DefaultEmail email={selectedEmail ?? undefined} />
          </div>
        </div>
      )}
    </div>
  );
};
interface EmailMenuProps {
  email: SimulationEmail;
  selected: boolean;
  onClick: () => void;
}
export const EmailMenu = ({ email, onClick, selected }: EmailMenuProps) => {
  const name = useAppSelector((state) => state.users.user.attributes.name);
  const body = getParsedEmailBody(
    name,
    i18nCText(email.attributes.simulationEmail.attributes.body)
  );
  const senderName = i18nCText(email.attributes.simulationEmail.attributes.senderName);
  const senderImage = email.attributes.simulationEmail.attributes.senderImage;
  const attachments = email.attributes.simulationEmail.attributes.attachments;
  const emailSentAt = email.attributes.sentAt;
  const subject = i18nCText(email.attributes.simulationEmail.attributes.subject);
  return (
    <div
      className={`email__menu__container ${selected ? 'email__menu__container__selected' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          onClick();
        }
      }}
    >
      <div>
        <img alt="..." className="avatar rounded-circle" src={senderImage} />
      </div>
      <div style={{ width: '100%' }}>
        <div className="email__menu__content">
          <div className="d-flex" style={{ gap: '8px', alignItems: 'center' }}>
            <h1 className="mb-0 text-base">{senderName}</h1>
          </div>
          <div className="d-flex align-items-center text-right text-muted" style={{ gap: '8px' }}>
            {attachments.length > 0 && <MdOutlineAttachment size={20} />}
            <small>
              <ReactTimeago date={emailSentAt ?? ''} />
            </small>
          </div>
        </div>
        <div className="mt-1">
          <h5 className="text-sm mb-0">
            <EllipsisText text={subject} length={45} />
          </h5>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <span className="email__menu__message">
            <EllipsisText text={decodeHTMLEntities(stripHtml(body)) || ''} length={30} />
          </span>
          <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            {!email.attributes.openedAt ? <Badge className="custom-badge">New</Badge> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailMessenger;

interface TabProps {
  index: number;
  activeTab: number;
  label: string;
  iconClass?: string;
  id: string;
  count: number;
  onClick: (index: number) => void;
}

const Tab: React.FC<TabProps> = ({ index, activeTab, label, onClick, count }) => {
  return (
    <NavItem>
      <NavLink
        aria-selected={activeTab === index}
        className={classnames('mb-sm-3 mb-md-0', { active: activeTab === index })}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          onClick(index);
        }}
        href="#pablo"
        role="tab"
      >
        {label} ({count})
      </NavLink>
    </NavItem>
  );
};

interface TabsProps {
  tabLabels: { label: string; iconClass?: string; id: string; count: number }[];
  children: React.ReactNode[];
}

export const Tabs: React.FC<TabsProps> = ({ tabLabels, children }) => {
  const [activeTab, setActiveTab] = useState(1);

  const toggleNavs = (index: number): void => {
    setActiveTab(index);
  };

  return (
    <>
      <div className="nav-wrapper email_nav_bar">
        <Nav className="nav-fill flex-column flex-md-row" id="tabs-icons-text" pills role="tablist">
          {tabLabels.map((tab, index) => (
            <Tab
              key={tab.id}
              index={index}
              activeTab={activeTab}
              label={tab.label}
              iconClass={tab.iconClass}
              onClick={toggleNavs}
              count={tab.count}
              id={tab.id}
            />
          ))}
        </Nav>
        <div>
          <Button className="btn-icon btn-2" type="button" color="primary">
            <FaPlusCircle />
            <span className="btn-inner--text">{translate('email.newConversation')}</span>
          </Button>
        </div>
      </div>
      <Card className="shadow">
        <CardBody>
          <TabContent activeTab={'tabs' + activeTab.toString()}>
            {children.map((child, index) => (
              <TabPane key={index} tabId={'tabs' + (index + 1).toString()}>
                {child}
              </TabPane>
            ))}
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

interface DefaultEmailProps {
  email: SimulationEmail | undefined;
}
export const DefaultEmail = ({ email }: DefaultEmailProps) => {
  const toMeEmailAddress = useAppSelector((state) => state.users.user.attributes.email);
  const name = useAppSelector((state) => state.users.user.attributes.name);

  if (!email) {
    return null;
  }
  const senderName = i18nCText(email.attributes.simulationEmail.attributes.senderName);
  const senderEmail = i18nCText(email.attributes.simulationEmail.attributes.senderEmail);
  const senderImage = email.attributes.simulationEmail.attributes.senderImage;
  const attachments = email.attributes.simulationEmail.attributes.attachments;
  const emailSentAt = email.attributes.sentAt;
  const subject = i18nCText(email.attributes.simulationEmail.attributes.subject);
  const body = getParsedEmailBody(
    name,
    i18nCText(email.attributes.simulationEmail.attributes.body)
  );
  return (
    <div className="default__email__container">
      <EmailView
        subject={subject}
        body={body}
        senderName={senderName}
        senderEmail={senderEmail}
        senderImage={senderImage}
        attachments={attachments}
        emailSentAt={emailSentAt ?? ''}
        toMeEmailAddress={toMeEmailAddress}
      />
    </div>
  );
};

export function EmailView(
  props: Readonly<{
    subject: string;
    body: string;
    senderName: string;
    senderEmail: string;
    senderImage: string;
    attachments: readonly { url: string; name: string }[];
    emailSentAt: string;
    toMeEmailAddress: string;
    replyToSimulationEmailId?: string;
  }>
) {
  const {
    subject,
    body,
    senderName,
    senderEmail,
    senderImage,
    attachments,
    emailSentAt,
    toMeEmailAddress,
    replyToSimulationEmailId,
  } = props;

  const [simulationEmail, setSimulationEmail] = useState<SimulationEmail | undefined>(undefined);
  const projectId = useAppSelector((state) => state.projects.currentProject.project.id);
  const name = useAppSelector((state) => state.users.user.attributes.name);
  useEffect(() => {
    if (replyToSimulationEmailId) {
      expEndpoints
        .getSimulationEmailById(projectId, replyToSimulationEmailId)
        .then((res) => {
          setSimulationEmail(res.data.data);
        })
        .catch(() => {
          logger.error('Failed to fetch simulation email');
        });
    }
  }, [replyToSimulationEmailId]);

  const replyEmailSentAt = i18nCText(simulationEmail?.attributes.sentAt ?? '');
  const replySenderEmail = i18nCText(
    simulationEmail?.attributes.simulationEmail.attributes.senderEmail ?? ''
  );
  const replyAttachments = simulationEmail?.attributes.simulationEmail.attributes.attachments;
  const replyBody = getParsedEmailBody(
    name,
    i18nCText(simulationEmail?.attributes.simulationEmail.attributes.body ?? '')
  );
  return (
    <Card className="default__email__card">
      <CardTitle className="mb-3" tag="h2">
        {subject}
      </CardTitle>
      <div className="default__email__header">
        <h2 className="default__email__header__title">
          <img alt="..." className="avatar rounded-circle" src={senderImage} />
          <div>
            <h1 className="mb-0 text-sm">
              {senderName}
              <small className="ml-2 default__email__header__subtext">{senderEmail}</small>
            </h1>
            <small className="default__email__header__toEmailAddress">
              {translate('email.to')} {toMeEmailAddress}
            </small>
          </div>
        </h2>
        <div className="default__email__header__actions">
          {attachments.length > 0 && <GrAttachment size={20} color="gray" />}
          <small className="default__email__header__subtext">
            <ReactTimeago date={emailSentAt} />
          </small>
        </div>
      </div>

      <div className="email__body">
        <EmailBody defaultValue={body} />
      </div>
      {attachments.length > 0 ? <Attachments attachments={attachments} /> : null}
      {replySenderEmail && replyAttachments && replyEmailSentAt && replyBody ? (
        <div className="fixed-text-preview">
          {translate('email.on')} {moment(replyEmailSentAt).format('MMMM Do YYYY, h:mm:ss a')},
          <span style={{ margin: '0 6px', fontWeight: 700 }}>{replySenderEmail}</span>
          {translate('email.wrote')}:
          <br />
          <div className="pl-4 ml-2" style={{ borderLeft: 'solid 1px #d8d8d8' }}>
            <EmailBody defaultValue={replyBody} />
            {replyAttachments.length && replyAttachments.length > 0 ? (
              <Attachments attachments={replyAttachments} />
            ) : null}
          </div>
        </div>
      ) : null}
    </Card>
  );
}
export function Attachments(
  props: Readonly<{
    attachments: readonly { url: string; name: string }[];
  }>
) {
  const { attachments } = props;
  return (
    <div className="email__attachments">
      <h5 className="email__attachments__title">
        {translate('email.attachmentsTitle')} ({attachments.length})
      </h5>
      <div className="emailPage__attachments__container">
        {attachments.map((attachment) => {
          const attachmentKey = `${attachment.name}-${attachment.url}`;
          return (
            <button
              key={attachmentKey}
              type="button"
              className="email__attachments__item email__attachments__content"
              onClick={() => {
                if (attachment.url.includes('.pdf')) {
                  let url = btoa(btoa(btoa(attachment.url)));
                  url = `${window.location.origin}/resource/${url}`;
                  redirectToExternal(url);
                } else {
                  redirectToExternal(attachment.url);
                }
              }}
            >
              <div className="email__attachments__icon">
                <PiPaperclip className="" size={24} />
              </div>
              <div className="email__attachment__name">{attachment.name}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

// EmailBody component
const EmailBody = forwardRef<
  HTMLDivElement,
  {
    defaultValue?: string;
  }
>((props, ref) => {
  const { defaultValue } = props;

  if (!defaultValue) {
    return <div className="email-editor-empty">No content available</div>;
  }

  return (
    <div
      className="email-editor-content"
      ref={ref}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(defaultValue) }}
    />
  );
});

EmailBody.displayName = 'EmailBody';
